import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { JsonLdService, SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
@Component({
  selector: 'app-generalopticals',
  templateUrl: './generalopticals.component.html',
  styleUrls: ['./generalopticals.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class GeneralopticalsComponent {
  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private seoService: SeoSocialShareService,private jsonLdService: JsonLdService,
  private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object){
    if (isPlatformBrowser(this.platformId)) {
    // this.title.setTitle('Revolutionize Optical Shops with Medeil Software');

    // // Add meta tags dynamically
    // this.meta.addTag({ name: 'description', content: 'Transform your optical store with automated processes for spectacle store business with efficient optical software. Boost ROI today!' });
    // this.meta.addTag({ name: 'keywords', content: 'optical shop management system, optical shop software, optical software for retail stores, optical retail shop software, optical retail store software' });
    this.setSeoMeta();
    this.setSchema();
    this.setFaqSchemaData();
    this.setWebsiteSchema()
  this.timezone=sessionStorage.getItem('timezone');
  this.enquiryForm=this.fb.group({
      leadname: ['',[ Validators.required]],
      organizationname: ['',[Validators.required]],
      leadsourceid: ['',[]],
      leadsource: ['medeil website',[]],
      sourceRef1: ['',[]],
      sourceRef2: ['',[]],
      description: ['',[ Validators.required]],
      primaryphone: ['',[Validators.required]],
      primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['',[]],
      address2: ['',[]],
      country: [sessionStorage.getItem('country'),[],[]],
      countryname1: ['0',[]],
      state: [sessionStorage.getItem('state'),[]],
      city: [sessionStorage.getItem('city'),[]],
      enteredcaptcha: ['',[]],
      generatedcaptcha: ['',[]],
      phonedialcode:['',[]],
      checkbox:[false,[]],
      appfrmtime:['',[]],
      apptotime:['',[]],
      appointmentdate:['',[]],
    })
  }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.mainservice.generatecaptcha();
    this.captcha = localStorage.getItem('captcha')
     // ----country list--
     this.mainservice.getCountryList().subscribe(data=>{
       console.log(data);
       this.totalcountry=data;
     })
    }
  }
  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: 'Optical Store Software | Manage Your Optical Business Seamlessly',
  //     description: 'Optimize your optical store operations with Medeil\'s software. Manage inventory, prescriptions, and sales with ease. Try it now!',
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/industry/optical-store-management',
  //     keywords: 'Optical store software, optical inventory management, optical POS system, optical business software, optical billing software.'
  //   };

  //   this.seoService.setData(seoData);
  // }
  // setWebsiteSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "WebSite",
  //     "name": "Medeil Optical Store Software",
  //     "url": "https://www.medeil.com",
  //     "description": "Medeil Optical Store Software helps optical businesses manage inventory, prescriptions, billing, and sales efficiently. Enhance your store operations with our advanced solutions.",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "publisher": {
  //       "@type": "Organization",
  //       "name": "Medeil",
  //       "url": "https://www.medeil.com",
  //       "logo": {
  //         "@type": "ImageObject",
  //         "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
  //       }
  //     }
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }

  // setSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "SoftwareApplication",
  //     "name": "Medeil Optical Store Software",
  //     "url": "https://www.medeil.com/industry/optical-store-management",
  //     "description": "Optimize your optical store operations with Medeil's software. Manage inventory, prescriptions, and sales with ease. Try it now!",
  //     "applicationCategory": "BusinessApplication",
  //     "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "offers": {
  //       "@type": "Offer",
  //       "priceCurrency": "USD",
  //       "availability": "https://schema.org/InStock",
  //       "url": "https://www.medeil.com/industry/optical-store-management",
  //       "keywords": "Optical store software, optical inventory management, optical POS system, optical business software, optical billing software."
  //     },
  //     "aggregateRating": {
  //       "@type": "AggregateRating",
  //       "ratingValue": "4.6",
  //       "ratingCount": "8864"
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setFaqSchemaData() {
  //   const faqSchema = {
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": [
  //       {
  //         "@type": "Question",
  //         "name": "Which functions are available in your optical software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Clients frequently inquire about the features and functionalities of the platform, such as the ability to virtually try on items, manage frame inventories, schedule appointments, integrate with electronic health records (EHR), and access reporting tools."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Does your optical software work with the systems and hardware we now have?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Yes, this inquiry pertains to compatibility issues with current hardware, including electronic health records (EHR), point-of-sale (POS) systems, and other software programs utilized by optical enterprises. Our solution is compatible with current computers, tablets, and smartphones."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Is it possible to modify your optical program to meet our unique requirements?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Many optical firms want to know if the software can be customized to meet their specific demands because they have different requirements and workflows. Customizing fields, reports, processes, and integrations may fall under this category."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "How long does it take to get up and running, and what is the process like for implementation?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Optical firms frequently want to know about the implementation process, timeline, training options, and continuing support provided because it can be a substantial undertaking to implement new software. The SaaS application is our solution. Your subscription account can be activated in a matter of minutes."
  //         }
  //       }
  //     ]
  //   };

  //   this.addJsonLdToHead(faqSchema);
  // }


  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: $localize`:@@OPTICAL_SOFTWARE.SEO_TITLE:Optical Store Software | Manage Your Optical Business Seamlessly`,
  //     description: $localize`:@@OPTICAL_SOFTWARE.SEO_DESCRIPTION:Optimize your optical store operations with Medeil's software. Manage inventory, prescriptions, and sales with ease. Try it now!`,
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/industry/optical-store-management',
  //     keywords: $localize`:@@OPTICAL_SOFTWARE.SEO_KEYWORDS:Optical store software, optical inventory management, optical POS system, optical business software, optical billing software.`
  //   };
  //   this.seoService.setData(seoData);
  // }
  setSeoMeta() {
  const supportedLanguages = ['en', 'fr', 'es', 'pt'];
  let finalUrl = '';

  if (isPlatformBrowser(this.platformId)) {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const parts = path.split('/');

    let lang = 'en'; // Default
    if (supportedLanguages.includes(parts[1])) {
      lang = parts[1];
    }

    // const fullPath = path.replace(/^\/[a-z]{2}/, '');
    // finalUrl = `${origin}/${lang}${fullPath}`;
    const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

  }

    const seoData = {
      title: $localize`:@@OPTICAL_SOFTWARE.SEO_TITLE:Optical Store Software | Manage Your Optical Business Seamlessly`,
  //     description: $localize`:@@OPTICAL_SOFTWARE.SEO_DESCRIPTION:Optimize your optical store operations with Medeil's software. Manage inventory, prescriptions, and sales with ease. Try it now!`,
      description:$localize`:@@OPTICAL_SOFTWARE.SEO_DESCRIPTION:Optimize your optical store operations with Medeil's software. Manage inventory, prescriptions, and sales with ease. Try it now!`,
      image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
      url: finalUrl,
      keywords:  $localize`:@@OPTICAL_SOFTWARE.SEO_KEYWORDS:Optical store software, optical inventory management, optical POS system, optical business software, optical billing software.`
    };

    this.title.setTitle(seoData.title);
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
  }

  setWebsiteSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": $localize`:@@OPTICAL_SOFTWARE.WEBSITE_NAME:Medeil Optical Store Software`,
      "url": "https://www.medeil.com",
      "description": $localize`:@@OPTICAL_SOFTWARE.WEBSITE_DESCRIPTION:Medeil Optical Store Software helps optical businesses manage inventory, prescriptions, billing, and sales efficiently. Enhance your store operations with our advanced solutions.`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
        }
      }
    };
    this.jsonLdService.setData(schemaData);
  }

  setSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": $localize`:@@OPTICAL_SOFTWARE.SCHEMA_NAME:Medeil Optical Store Software`,
      "url": "https://www.medeil.com/industry/optical-store-management",
      "description": $localize`:@@OPTICAL_SOFTWARE.SCHEMA_DESCRIPTION:Optimize your optical store operations with Medeil's software. Manage inventory, prescriptions, and sales with ease. Try it now!`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": $localize`:@@OPTICAL_SOFTWARE.OS:Cloud-based (Web, Windows, macOS, Linux)`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock",
        "url": "https://www.medeil.com/industry/optical-store-management",
        "keywords": $localize`:@@OPTICAL_SOFTWARE.SEO_KEYWORDS:Optical store software, optical inventory management, optical POS system, optical business software, optical billing software.`
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      }
    };
    this.jsonLdService.setData(schemaData);
  }

  setFaqSchemaData() {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": $localize`:@@OPTICAL_SOFTWARE.FAQ_1_Q:Which functions are available in your optical software?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@OPTICAL_SOFTWARE.FAQ_1_A:Clients frequently inquire about the features and functionalities of the platform, such as the ability to virtually try on items, manage frame inventories, schedule appointments, integrate with electronic health records (EHR), and access reporting tools.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@OPTICAL_SOFTWARE.FAQ_2_Q:Does your optical software work with the systems and hardware we now have?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@OPTICAL_SOFTWARE.FAQ_2_A:Yes, this inquiry pertains to compatibility issues with current hardware, including electronic health records (EHR), point-of-sale (POS) systems, and other software programs utilized by optical enterprises. Our solution is compatible with current computers, tablets, and smartphones.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@OPTICAL_SOFTWARE.FAQ_3_Q:Is it possible to modify your optical program to meet our unique requirements?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@OPTICAL_SOFTWARE.FAQ_3_A:Many optical firms want to know if the software can be customized to meet their specific demands because they have different requirements and workflows. Customizing fields, reports, processes, and integrations may fall under this category.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@OPTICAL_SOFTWARE.FAQ_4_Q:How long does it take to get up and running, and what is the process like for implementation?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@OPTICAL_SOFTWARE.FAQ_4_A:Optical firms frequently want to know about the implementation process, timeline, training options, and continuing support provided because it can be a substantial undertaking to implement new software. The SaaS application is our solution. Your subscription account can be activated in a matter of minutes.`
          }
        }
      ]
    };
    this.addJsonLdToHead(faqSchema);
  }


  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if it exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }

  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha(){
    this.mainservice.generatecaptcha()
    this.captcha = localStorage.getItem('captcha')
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();

  }
  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }
  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;



    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElementsave=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();

  })

  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');
  }
  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();
    }

  }
}
